(function () {
  document.querySelectorAll('media-gallery').forEach(function (gallery) {
    var arrows = gallery.querySelector('.dbu-arrows');
    if (!arrows) return;
    var prevBtn = arrows.querySelector('.dbu-prev');
    var nextBtn = arrows.querySelector('.dbu-next');
    var list = gallery.querySelector('.product__media-list');

    var visible = function (el) { return el && el.offsetParent !== null; };
    var thumbs = function () {
      var t = gallery.querySelector('.thumbnail-list');
      if (!visible(t)) return [];
      return Array.from(t.querySelectorAll('.thumbnail-list__item[data-target]'));
    };
    var activeThumb = function (items) {
      return items.findIndex(function (item) {
        var b = item.querySelector('button');
        return b && b.getAttribute('aria-current') === 'true';
      });
    };
    var slides = function () {
      return list ? Array.from(list.querySelectorAll('.product__media-item')).filter(visible) : [];
    };
    var canScroll = function () { return list && list.scrollWidth > list.clientWidth + 2; };
    var activeSlide = function (items) {
      if (!items.length) return 0;
      var left = list.scrollLeft, best = 0, bestDist = Infinity;
      items.forEach(function (s, i) {
        var d = Math.abs(s.offsetLeft - items[0].offsetLeft - left);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    };

    var update = function () {
      var t = thumbs();
      var total, idx;
      if (t.length) {
        arrows.classList.remove('dbu-arrows--no-thumbs');
        total = t.length; idx = activeThumb(t);
      } else if (canScroll()) {
        arrows.classList.add('dbu-arrows--no-thumbs');
        var s = slides(); total = s.length; idx = activeSlide(s);
      } else {
        total = 0;
      }
      if (total <= 1) { arrows.style.display = 'none'; return; }
      arrows.style.display = 'block';
      prevBtn.disabled = idx <= 0;
      nextBtn.disabled = idx >= total - 1;
    };

    var go = function (dir) {
      var t = thumbs();
      if (t.length) {
        var i = activeThumb(t); if (i === -1) i = 0;
        var n = i + dir;
        if (n < 0 || n >= t.length) return;
        var b = t[n].querySelector('button');
        if (b) b.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        setTimeout(update, 150);
      } else if (canScroll()) {
        var s = slides();
        var j = activeSlide(s) + dir;
        if (j < 0 || j >= s.length) return;
        list.scrollTo({ left: s[j].offsetLeft - s[0].offsetLeft, behavior: 'smooth' });
      }
    };

    prevBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); go(1); });

    var thumbList = gallery.querySelector('.thumbnail-list');
    if (thumbList) {
      new MutationObserver(function () { setTimeout(update, 50); })
        .observe(thumbList, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
    }
    if (list) list.addEventListener('scroll', function () { clearTimeout(list._dbuT); list._dbuT = setTimeout(update, 80); });
    window.addEventListener('resize', update);
    setTimeout(update, 300);
  });
})();
